import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DlsSharedModule} from "../../../dls-shared.module";
import {CoreModule} from "@ispm/core/core.module";
import {LayoutModule} from "@ispm/layout/layout.module";
import {CommonModule as WuitkCommonModule} from '@wuitk/angular/components/common';
import {ConfigurationModule} from "../../../configuration/configuration.module";
import {NavigationModule} from "@ispm/navigation/navigation.module";
import { HOME_COMPONENTS, HOME_SERVICES } from '.';
import {CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA} from '@angular/core';
import { CurationModule } from '../../../curation/curation.module';
import {DashboardMenuModule} from "@ispm/dashboard/menu/menu.module";
import { AskAIModule } from '@ispm/dashboard/ask-ai/ask-a-i.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DlsSharedModule,
    DashboardMenuModule,
    ConfigurationModule.forRoot(),
    CoreModule,
    LayoutModule,
    WuitkCommonModule,
    CurationModule,
    NavigationModule,
    AskAIModule
  ],
  declarations: [...HOME_COMPONENTS],
  exports: [...HOME_COMPONENTS],
  providers: [...HOME_SERVICES],
  schemas : [CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA]
})
export class ISPMHomeModule { }
